import { CouponsContainer } from '@/modules/Coupons';

export const Coupons = (): JSX.Element => <CouponsContainer />;

export default Coupons;
